import * as actionTypes from "../constants/actionTypes";
import * as languages from "../constants/languages";
import * as settings from "../constants/settings";
import * as componentTypes from "../constants/componentTypes";
import * as orderBy from "../constants/orderBy";
import * as config from "../constants/config";
import * as rcc from "../constants/rcc";
import * as styles from "../constants/styles";
import * as modelHelper from "../helpers/modelHelper";
import * as settingsHelper from "../helpers/settingsHelper";
import * as validationHelper from "../helpers/validationHelper";
import * as windowService from "../services/windowService";

export const initialState = {
    options: {},
    activeScreensaver: windowService.getScreenSaver(),
    additionalTabType: componentTypes.MAIN_TAB,
    alternativeFormulasPosition: null,
    autoCloseTab: false,
    automaticClientStart: false,
    automaticLogout: false,
    automaticLogoutTimeout: 10,
    automaticPrint: true,
    barcodesEnabled: false,
    blendFormulaAndCode: false,
    buildingSite: false,
    cleaningTime: rcc.RCC_DEFAULT_CLEAN_TIME,
    colorantBatchForMultipleCans: false,
    colorantBatchNumberLogic: settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
    colorantPanelLimit: 3,
    colorantPanelOrderBy: null,
    colorPreviewAsImage: false,
    colorPreviewResizable: null,
    colorTabCompatibleOnly: true,
    colorTabFormulaCode: true,
    colorTabFormulaName: true,
    colorTabNoteIcons: true,
    colorTabOrderBy: settings.COLOR_PANEL_SORTING_TYPE_FORMULA_NAME,
    colorTabRowCount: 40,
    colorTabWarningIcon: true,
    competitiveColorSearch: true,
    customBannerPosition: null,
    customCanOption: null,
    customCanSettingsUnitGrav: null,
    customCanSettingsUnitVol: null,
    customCanSizeEnabled: true,
    customCanUnits: [],
    customersEnabled: true,
    customFormatCurrency: null,
    customFormatDate: null,
    customFormatNumber: null,
    customFormatTime: null,
    customFormulaForMasterProduct: true,
    customFormulaForMasterProductDefault: false,
    customFormulas: true,
    customHomeButton: null,
    deleteConfirmation: true,
    diskSpaceNotification: true,
    dispensingEnabled: true,
    dispensingNotes: true,
    dispensingWithErrorsEnabled: true,
    editColorantAllowance: false,
    fandeckGroups: false,
    fileTransfer: true,
    fileTransferInTasks: [],
    fileTransferOutTasks: [],
    formulaAutomaticNaming: false,
    formulaCode: false,
    formulaCodePrimary: false,
    formulaColorPreview: true,
    formulaInfoData: [],
    formulaInfoItemInRgbPreview: null,
    formulaModificationPanel: false,
    formulaName: true,
    formulaNotes: true,
    formulaPreview: settings.PREVIEW_IMAGE,
    formulaPropertiesPosition: null,
    formulaStatusPanel: false,
    formulaUnits: settings.UNIT_ML,
    fts: true,
    generateColorPreview: false,
    gdprEnabled: false,
    helperAutoDownload: false,
    helperAutoForceInstall: false,
    helperAutoCheck: true,
    helperAutoCheckInterval: 24,
    helperAutoInstall: false,
    helperAutoInstallDelay: 15,
    helperAutoInstallNewDbs: false,
    helperAutoNightCheck: false,
    helperAutoRebootDelay: 15,
    helpLink: null,
    helpSettings: settingsHelper.parseHelpItems(null),
    historicalFormulasPosition: settings.POSITION_COLORANT_PANEL,
    imagesSource: settings.SOURCE_LOCAL,
    infoPanelResizable: null,
    infoPanelTab: settings.INFO_PANEL_PACKAGE,
    initialTabType: componentTypes.MAIN_TAB,
    intergammaColorFandeckWizard: false,
    intergammaMachineSortingOrders: orderBy.UPDATED,
    keyboard: languages.ENGLISH,
    keyboardShortcuts: null,
    kiosk: windowService.isKioskActive(),
    lastUsedUnit: settings.UNIT_ML,
    lightAtStartup: windowService.getLightAtStartup(),
    lightEnabled: true,
    locale: windowService.getLanguage(),
    lockComputer: windowService.getLockComputer(),
    manualAdditionUnit: settings.UNIT_ML,
    masterProductName: false,
    masterProductSiblingsTable: false,
    matchingInfoCr: true,
    matchingInfoDeltaE1: true,
    matchingInfoDeltaE2: true,
    matchingInfoDeltaE3: true,
    matchingInfoDin: true,
    matchingInfoLrv: true,
    matchingInfoRms: true,
    matchingOptionsColorants: true,
    matchingOptionsColorfile: true,
    matchingOptionsSortResults: true,
    matchingRowCount: config.DEFAULT_MATCHING_ROW_COUNT,
    matchingTableBase: true,
    matchingTableColorants: true,
    matchingTableCr: true,
    matchingTableDeltaE1: true,
    matchingTableDeltaE2: true,
    matchingTableDeltaE3: true,
    matchingTableDin: true,
    matchingTableLrv: true,
    matchingTablePrice: true,
    matchingTableRms: true,
    maxNumberOfTabs: config.DEFAULT_FORMULA_TAB_LIMIT,
    maxToleranceForCompetitiveColors: 5,
    moreInfoInternal: true,
    navigationItems: [],
    numberOfCompetitiveColors: 1,
    orderingEnabled: false,
    orderModalEnabled: false,
    orderSearchItemsEnabled: [],
    overwriteHelperConfig: false,
    overwriteLastTab: false,
    overwriteLogo: false,
    overwriteMachineConfig: false,
    partialUpdatesInactivityTimer: 60,
    partialUpdatesRemindInterval: 10,
    priceTypes: [],
    priceVisibilityType: settings.WITH_AND_WITHOUT_VAT_OPTION,
    pricingEnabled: false,
    printAfterDispensing: false,
    printAsImage: false,
    printBeforeDispensing: true,
    printEnabled: true,
    printer: null,
    printerTemplate: null,
    printerTemplateQuickTint: null,
    printOnRequest: true,
    printTasksAfterDispensing: [],
    printTasksBeforeDispensing: [],
    productCode: false,
    productFilesSource: settings.SOURCE_LOCAL,
    productGroups: true,
    productImagePreview: false,
    qualityControlDifference: null,
    qualityControlDeltaA: null,
    qualityControlDeltaB: null,
    qualityControlDeltaE: null,
    qualityControlDeltaL: null,
    qualityControlMetamerism: null,
    qualityControlEnabled: null,
    quickTintSortingType: settings.QUICK_TINT_SORTING_TYPE_ALPHA,
    quickTintWindowCloseAfterDispensing: true,
    rccBarcodeRefill: settings.RCC_ENABLED,
    rccBaseCanBarcodeValidation: false,
    rccDispenseInvalidColorants: false,
    rccCheckCanBeforeDispense: true,
    rccCheckOverfill: false,
    rccManualColorantAddition: settings.RCC_ENABLED,
    rccMinimalDispenseAmount: 2,
    rccPlaceCanSensor: true,
    rccPlaceCanSensorDelay: 10,
    rccRemoveCanSensor: true,
    rccRemoveCanSensorDelay: 10,
    rccSkipPlaceCanDialog: false,
    rccSkipRemoveCanDialog: false,
    rccSplitFormula: settings.RCC_ENABLED,
    rccTmcEnabled: true,
    rccUnit: settings.UNIT_KG,
    rccValidateColorantsDuringInit: true,
    recirculationSpeed: rcc.RCC_DEFAULT_RECIRCULATE_SPEED,
    recirculationTime: rcc.RCC_DEFAULT_RECIRCULATE_TIME,
    rounding: settings.DEFAULT_ROUNDING,
    screensaverTimeout: windowService.getScreenSaverTime(),
    searchCheaperColors: true,
    searchPanelBase: false,
    searchPanelBaseSize: 1,
    searchPanelBipp: false,
    searchPanelBippSize: 1,
    searchPanelDropDownCalculate: true,
    searchPanelFandeckSize: 1,
    searchPanelFormulaSize: 1,
    searchPanelOrder: [
        componentTypes.SEARCH_PANEL_PRODUCT,
        componentTypes.SEARCH_PANEL_FANDECK,
        componentTypes.SEARCH_PANEL_FORMULA_NAME,
        componentTypes.SEARCH_PANEL_FORMULA_CODE
    ],
    searchPanelOrderByDistance: false,
    searchPanelProduct: true,
    searchPanelProductSize: 1,
    searchPanelQuickSelect: false,
    shotsCoef: 1,
    shotsName: "",
    softwareName: config.DEFUALT_SOFTWARE_NAME,
    softwareNameLight: config.DEFAULT_SOFTWARE_NAME_LIGHT,
    soundEnabled: true,
    spectroEnabled: true,
    stirringSpeed: rcc.RCC_DEFAULT_STIR_TIME,
    stirringTime: rcc.RCC_DEFAULT_STIR_TIME,
    stockDatabaseFilter: null,
    stockTableOrderBy: settings.STOCK_TABLE_ORDER_BY_COLORANT_NAME,
    style: windowService.getCustomStyle(),
    tableAnswer: true,
    tableBase: true,
    tableBipp: false,
    tableBuildingSite: false,
    tableClientName: false,
    tableColorName: true,
    tableComment: false,
    tableCreated: true,
    tableCustomer: true,
    tableDate: true,
    tableFandeck: true,
    tableFormulaCode: true,
    tableFormulaName: true,
    tableMoreInfo: true,
    tableMoreInfoInternal: true,
    tableOperator: true,
    tablePackage: true,
    tableProduct: true,
    tableQualityControl: false,
    tableQuantity: true,
    tableStatus: true,
    tableSubject: false,
    tableTicketId: true,
    tableType: true,
    tabsEnabled: true,
    tabsMemory: false,
    tintometricSystem: null,
    tintometricSystemsEnabled: false,
    ufiCodeBaseValidation: settings.UFI_CODE_BASE_VALIDATION_DISABLED,
    ufiCodeLogic: settings.UFI_CODE_LOGIC_DISABLED,
    ufiCodeMinAmountGravPercent: 0,
    ufiCodeMinGravPercent: 0,
    userIdentificationEnabled: false,
    validateColorantBaseRules: false,
    validateMinDosableAmount: false,
    validateOverfill: false,
    validateTotalCntAmounts: false,
    virtualKeyboardEnabled: true,
    visibleUnits: {ml: true, g: true, shots: true},
    weberCanBigLowerBound: windowService.getWeberCanBigLowerBound(),
    weberCanBigUpperBound: windowService.getWeberCanBigUpperBound(),
    weberCanCoatingLowerBound: windowService.getWeberCanCoatingLowerBound(),
    weberCanCoatingUpperBound: windowService.getWeberCanCoatingUpperBound(),
    weberCanLaboratoryLowerBound: windowService.getWeberCanLaboratoryLowerBound(),
    weberCanLaboratoryUpperBound: windowService.getWeberCanLaboratoryUpperBound(),
    weberCanSmallLowerBound: windowService.getWeberCanSmallLowerBound(),
    weberCanSmallUpperBound: windowService.getWeberCanSmallUpperBound(),
    weberCoatingNames: windowService.getWeberCoatingNames(),
    weberPlasterNames: windowService.getWeberPlasterNames(),
    zoom: settings.DEFAULT_ZOOM
};

/**
 * Structure of settings store:
 * - options {Array}                            - array of all possible options for settings with more potential values
 * - activeScreensaver {Boolean}
 * - additionalTabType {String}
 * - alternativeFormulasPosition {String | null}
 * - autoCloseTab {Boolean}
 * - automaticClientStart {Boolean}
 * - automaticLogout {Boolean}
 * - automaticLogoutTimeout {Boolean}
 * - automaticPrint {Boolean}
 * - barcodesEnabled {Boolean}
 * - blendFormulaAndCode {Boolean}
 * - buildingSite {Boolean}
 * - cleaningTime {Number}
 * - colorantBatchForMultipleCans: {Boolean},
 * - colorantBatchNumberLogic {Number}
 * - colorantPanelLimit {Number}
 * - colorantPanelOrderBy {String | null}
 * - colorPreviewAsImage {Boolean}
 * - colorPreviewResizable {String | null}
 * - colorTabCompatibleOnly {Boolean}
 * - colorTabFormulaCode {Boolean}
 * - colorTabFormulaName {Boolean}
 * - colorTabNoteIcons {Boolean}
 * - colorTabOrderBy {String}
 * - colorTabRowCount {Number}
 * - colorTabWarningIcon {Boolean}
 * - competitiveColorSearch {Boolean}
 * - customBannerPosition {String | null}
 * - customCanOption {String | null}
 * - customCanSettingsUnitGrav {String | null}
 * - customCanSettingsUnitVol {String | null}
 * - customCanSizeEnabled {Boolean}
 * - customCanUnits {String | null}
 * - customersEnabled {Boolean}
 * - customFormatCurrency {String | null}
 * - customFormatDate {String | null}
 * - customFormatNumber {String | null}
 * - customFormatTime {String | null}
 * - customFormulaForMasterProduct {Boolean}
 * - customFormulaForMasterProductDefault {Boolean}
 * - customFormulas {Boolean}
 * - customHomeButton {String | null}
 * - deleteConfirmation {Boolean}
 * - diskSpaceNotification {Boolean}
 * - dispensingEnabled {Boolean}
 * - dispensingNotes {Boolean}
 * - dispensingWithErrorsEnabled {Boolean}
 * - fandeckGroups {Boolean}
 * - editColorantAllowance {Boolean}
 * - fileTransfer {Boolean}
 * - fileTransferInTasks {Array}
 * - fileTransferOutTasks {Array}
 * - formulaAutomaticNaming {Boolean}
 * - formulaCode {Boolean}
 * - formulaCodePrimary {Boolean}
 * - formulaColorPreview {Boolean}
 * - formulaInfoData {Array}
 * - formulaInfoItemInRgbPreview {String}
 * - formulaModificationPanel {Boolean}
 * - formulaName {Boolean}
 * - formulaNotes {Boolean}
 * - formulaPreview {String}
 * - formulaStatusPanel {Boolean}
 * - formulaUnits {String}
 * - fts {Boolean}
 * - generateColorPreview {Boolean}
 * - gdprEnabled {Boolean}
 * - helperAutoDownload {Boolean}
 * - helperAutoForceInstall {Boolean}
 * - helperAutoCheck {Boolean}
 * - helperAutoCheckInterval {Number}
 * - helperAutoInstall {Boolean}
 * - helperAutoInstallDelay {Number}
 * - helperAutoInstallNewDbs {Boolean}
 * - helperAutoNightCheck {Boolean}
 * - helperAutoRebootDelay {Number}
 * - helpLink {String}
 * - helpSettings {Object}
 * - historicalFormulasPosition {String | null}
 * - imagesSource {String}
 * - infoPanelResizable {String | null}
 * - infoPanelTab {String}
 * - initialTabType {String}
 * - intergammaColorFandeckWizard {Boolean}
 * - intergammaMachineSortingOrders {String}
 * - keyboard {String}
 * - keyboardShortcuts {Array | null}
 * - kiosk {Boolean}
 * - lastUsedUnit {String}
 * - lightAtStartup {Boolean}
 * - lightEnabled {Boolean}
 * - locale {String}
 * - lockComputer {Boolean}
 * - manualAdditionUnit {String}
 * - masterProductName {Boolean}
 * - masterProductSiblingsTable {Boolean}
 * - matchingInfoCr {Boolean}
 * - matchingInfoDeltaE1 {Boolean}
 * - matchingInfoDeltaE2 {Boolean}
 * - matchingInfoDeltaE3 {Boolean}
 * - matchingInfoDin {Boolean}
 * - matchingInfoLrv {Boolean}
 * - matchingInfoRms {Boolean}
 * - matchingOptionsColorants {Boolean}
 * - matchingOptionsColorfile {Boolean}
 * - matchingOptionsSortResults {Boolean}
 * - matchingRowCount {Number}
 * - matchingTableBase {Boolean}
 * - matchingTableColorants {Boolean}
 * - matchingTableCr {Boolean}
 * - matchingTableDeltaE1 {Boolean}
 * - matchingTableDeltaE2 {Boolean}
 * - matchingTableDeltaE3 {Boolean}
 * - matchingTableDin {Boolean}
 * - matchingTableLrv {Boolean}
 * - matchingTablePrice {Boolean}
 * - matchingTableRms {Boolean}
 * - maxNumberOfTabs {Number}
 * - maxToleranceOfCompetitiveColors {Number}
 * - moreInfoInternal {Boolean}
 * - navigationItems {Array}                    - defines visibility and order of navigation items
 * - numberOfCompetitiveColors {Number}
 * - orderingEnabled {Boolean}
 * - orderModalEnabled {Boolean}
 * - orderSearchItemsEnabled {Array}            - To dispense orders in Light are full text filtered by these options
 * - overwriteHelperConfig {Boolean}            - If true than sychronization of server helper config and helper config is active
 * - overwriteLastTab {Boolean}
 * - overwriteLogo {Boolean}
 * - overwriteMachineConfig {Boolean}           - If true than sychronization of server machine config and RCC machine config is active
 * - priceTypes {Array}
 * - priceVisibilityType {String}
 * - pricingEnabled {Boolean}
 * - printAfterDispensing {Boolean}
 * - printAsImage {Boolean}                     - Print as image?
 * - printBeforeDispensing {Boolean}
 * - printEnabled {Boolean}
 * - printer {String}
 * - printerTemplate {String}
 * - printerTemplateQuickTint {String}
 * - printOnRequest {Boolean}
 * - printTasksAfterDispensing {Array}
 * - printTasksBeforeDispensing {Array}
 * - productCode {Boolean}
 * - productFilesSource {String}
 * - productGroups {Boolean}
 * - productImagePreview {Boolean}
 * - quickTintSortingType {String}
 * - quickTintWindowCloseAfterDispensing {Boolean}
 * - rccBarcodeRefill {String}
 * - rccBaseCanBarcodeValidation {Boolean}
 * - rccDispenseInvalidColorants {Boolean}
 * - rccCheckCanBeforeDispense {Boolean}
 * - rccCheckOverfill {Boolean}
 * - rccManualColorantAddition {String}
 * - rccMinimalDispenseAmount {Number}
 * - rccPlaceCanSensor {Boolean}
 * - rccPlaceCanSensorDelay {Number}
 * - rccRemoveCanSensor {Boolean}
 * - rccRemoveCanSensorDelay {Number}
 * - rccSkipPlaceCanDialog {Boolean}
 * - rccSkipRemoveCanDialog {Boolean}
 * - rccSplitFormula {String}
 * - rccTmcEnabled {Boolean}
 * - rccUnit {String}
 * - rccValidateColorantsDuringInit {Boolean}
 * - recirculationSpeed {Number}
 * - recirculationTime {Number}
 * - rounding {Number}
 * - screensaverTimeout {Number}
 * - searchCheaperColors {Boolean}
 * - searchPanelBase {Boolean}
 * - searchPanelBaseSize {Number}
 * - searchPanelBipp {Boolean}
 * - searchPanelBippSize {Number}
 * - searchPanelDropDownCalculate {Boolean}
 * - searchPanelFandeckSize {Number}
 * - searchPanelFormulaSize {Number}
 * - searchPanelOrder {Array}
 * - searchPanelOrderByDistance {Boolean}
 * - searchPanelProduct {Boolean}
 * - searchPanelProductSize {Number}
 * - searchPanelQuickSelect {Boolean}
 * - shotsCoef {Number}
 * - shotsName {String}
 * - softwareName {String}
 * - softwareNameLight {String}
 * - soundEnabled {Boolean}
 * - spectroEnabled {Boolean}
 * - stirringSpeed {Number}
 * - stirringTime {Number}
 * - stockDatabaseFilter {String | null}
 * - stockTableOrderBy {Number}
 * - style {String}
 * - tableAnswer {Boolean}
 * - tableBase {Boolean}
 * - tableBipp {Boolean}
 * - tableBuildingSite {Boolean}
 * - tableClientName {Boolean}
 * - tableColorName {Boolean}
 * - tableComment {Boolean}
 * - tableCreated {Boolean}
 * - tableCustomer {Boolean}
 * - tableDate {Boolean}
 * - tableFandeck {Boolean}
 * - tableFormulaCode {Boolean}
 * - tableFormulaName {Boolean}
 * - tableMoreInfo {Boolean}
 * - tableMoreInfoInternal {Boolean}
 * - tableOperator {Boolean}
 * - tablePackage {Boolean}
 * - tableProduct {Boolean}
 * - tableQualityControl {Boolean}
 * - tableQuantity {Boolean}
 * - tableStatus {Boolean}
 * - tableSubject {Boolean}
 * - tableTicketId {Boolean}
 * - tableType {Boolean}
 * - tabsEnabled {Boolean}
 * - tabsMemory {Boolean}
 * - tintometricSystem {String | null}
 * - tintometricSystemsEnabled {Boolean}
 * - ufiCodeBaseValidation {Number}
 * - ufiCodeLogic {Number}
 * - ufiCodeMinAmountGravPercent {Number}
 * - ufiCodeMinGravPercent {Number}
 * - userIdentificationEnabled {Boolean}
 * - validateMinDosableAmount {Boolean}
 * - validateOverfill {Boolean}
 * - validateTotalCntAmounts {Boolean}
 * - virtualKeyboardEnabled {Boolean}
 * - visibleUnits {Object}
 * - weberCanBigLowerBound {Number}              - used for filtering big packages in ToDispense
 * - weberCanBigUpperBound {Number}              - used for filtering big packages in ToDispense
 * - weberCanCoatingLowerBound {Number}          - used for filtering coatings in ToDispense
 * - weberCanCoatingUpperBound {Number}          - used for filtering coatings in ToDispense
 * - weberCanLaboratoryLowerBound {Number}       - used for filtering laboratory packages in ToDispense
 * - weberCanLaboratoryUpperBound {Number}       - used for filtering laboratory packages in ToDispense
 * - weberCanSmallLowerBound {Number}            - used for filtering small packages in ToDispense
 * - weberCanSmallUpperBound {Number}            - used for filtering small packages in ToDispense
 * - weberCoatingNames {Array}                   - used for filtering coatings in ToDispense
 * - weberPlasterNames {Array}                   - used for filtering plasters in ToDispense
 * - zoom {Number}
 */
export const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
        case actionTypes.DATABASE_CHANGE_GAMMA:
            return initialState;
        case actionTypes.SAVE_SETTING_OPTIONS:
            return {
                ...state,
                options: action.payload
            };
        case actionTypes.INIT_USER_SETTINGS:
        case actionTypes.SAVE_USER_SETTINGS:
            if (state.kiosk !== action.payload.kiosk) {
                windowService.setKioskMode(action.payload.kiosk);
            }

            let customStyle = null;
            if (state.style === "" && styles.CUSTOM_STYLES.includes(action.payload.style)) {
                customStyle = action.payload.style;
                windowService.setStyle(action.payload.style);
            }

            window.storeProvider.setSettingItems(action.payload);

            let weberSettings = validationHelper.mergeWeberSettings(state, action.payload);

            const unitToShow = settingsHelper.checkLastUsedUnitVisibility(
                action.payload.lastUsedUnit,
                action.payload.visibleUnits,
                action.payload.formulaUnits
            );
            return {
                ...state,
                ...weberSettings,
                additionalTabType: action.payload.additionalTabType,
                alternativeFormulasPosition: action.payload.alternativeFormulasPosition,
                autoCloseTab: action.payload.autoCloseTab,
                automaticClientStart: action.payload.automaticClientStart,
                automaticLogout: action.payload.automaticLogout,
                automaticLogoutTimeout: action.payload.automaticLogoutTimeout,
                automaticPrint: action.payload.automaticPrint,
                barcodesEnabled: action.payload.barcodesEnabled,
                blendFormulaAndCode: action.payload.blendFormulaAndCode,
                buildingSite: action.payload.buildingSite,
                cleaningTime: action.payload.cleaningTime,
                colorantBatchForMultipleCans: action.payload.colorantBatchForMultipleCans,
                colorantBatchNumberLogic: action.payload.colorantBatchNumberLogic,
                colorantPanelLimit: action.payload.colorantPanelLimit,
                colorantPanelOrderBy: action.payload.colorantPanelOrderBy,
                colorPreviewAsImage: action.payload.colorPreviewAsImage,
                colorPreviewResizable: action.payload.colorPreviewResizable,
                colorTabCompatibleOnly: action.payload.colorTabCompatibleOnly,
                colorTabFormulaCode: action.payload.colorTabFormulaCode,
                colorTabFormulaName: action.payload.colorTabFormulaName,
                colorTabNoteIcons: action.payload.colorTabNoteIcons,
                colorTabOrderBy: action.payload.colorTabOrderBy,
                colorTabRowCount: action.payload.colorTabRowCount,
                colorTabWarningIcon: action.payload.colorTabWarningIcon,
                competitiveColorSearch: action.payload.competitiveColorSearch,
                customBannerPosition: action.payload.customBannerPosition,
                customCanOption: action.payload.customCanOption,
                customCanSettingsUnitGrav: action.payload.customCanSettingsUnitGrav,
                customCanSettingsUnitVol: action.payload.customCanSettingsUnitVol,
                customCanSizeEnabled: action.payload.customCanSizeEnabled,
                customCanUnits: action.payload.customCanUnits,
                customersEnabled: action.payload.customersEnabled,
                customFormatCurrency: action.payload.customFormatCurrency,
                customFormatDate: action.payload.customFormatDate,
                customFormatNumber: action.payload.customFormatNumber,
                customFormatTime: action.payload.customFormatTime,
                customFormulaForMasterProduct: action.payload.customFormulaForMasterProduct,
                customFormulaForMasterProductDefault: action.payload.customFormulaForMasterProductDefault,
                customFormulas: action.payload.customFormulas,
                customHomeButton: action.payload.customHomeButton,
                deleteConfirmation: action.payload.deleteConfirmation,
                diskSpaceNotification: action.payload.diskSpaceNotification,
                dispensingEnabled: action.payload.dispensingEnabled,
                dispensingNotes: action.payload.dispensingNotes,
                dispensingWithErrorsEnabled: action.payload.dispensingWithErrorsEnabled,
                editColorantAllowance: action.payload.editColorantAllowance,
                fandeckGroups: action.payload.fandeckGroups,
                fileTransfer: action.payload.fileTransfer,
                fileTransferInTasks: modelHelper.mapFileTransferInTasksToObjects(action.payload.fileTransferInTasks),
                fileTransferOutTasks: modelHelper.mapFileTransferOutTasksToObjects(action.payload.fileTransferOutTasks),
                formulaAutomaticNaming: action.payload.formulaAutomaticNaming,
                formulaCode: action.payload.formulaCode,
                formulaCodePrimary: action.payload.formulaCodePrimary,
                formulaColorPreview: action.payload.formulaColorPreview,
                formulaInfoData: action.payload.formulaInfoData,
                formulaInfoItemInRgbPreview: action.payload.formulaInfoItemInRgbPreview,
                formulaModificationPanel: action.payload.formulaModificationPanel,
                formulaName: action.payload.formulaName,
                formulaNotes: action.payload.formulaNotes,
                formulaPreview: action.payload.formulaPreview,
                formulaPropertiesPosition: action.payload.formulaPropertiesPosition,
                formulaStatusPanel: action.payload.formulaStatusPanel,
                formulaUnits: action.payload.formulaUnits,
                fts: action.payload.fts,
                generateColorPreview: action.payload.generateColorPreview,
                gdprEnabled: action.payload.gdprEnabled,
                helperAutoDownload: action.payload.helperAutoDownload,
                helperAutoForceInstall: action.payload.helperAutoForceInstall,
                helperAutoCheck: action.payload.helperAutoCheck,
                helperAutoCheckInterval: action.payload.helperAutoCheckInterval,
                helperAutoInstall: action.payload.helperAutoInstall,
                helperAutoInstallDelay: action.payload.helperAutoInstallDelay,
                helperAutoInstallNewDbs: action.payload.helperAutoInstallNewDbs,
                helperAutoNightCheck: action.payload.helperAutoNightCheck,
                helperAutoRebootDelay: action.payload.helperAutoRebootDelay,
                helpLink: action.payload.helpLink,
                helpSettings: action.payload.helpSettings,
                historicalFormulasPosition: action.payload.historicalFormulasPosition,
                imagesSource: action.payload.imagesSource,
                infoPanelResizable: action.payload.infoPanelResizable,
                infoPanelTab: action.payload.infoPanelTab,
                initialTabType: action.payload.initialTabType,
                intergammaColorFandeckWizard: action.payload.intergammaColorFandeckWizard,
                intergammaMachineSortingOrders: action.payload.intergammaMachineSortingOrders,
                keyboard: action.payload.keyboard,
                keyboardShortcuts: modelHelper.mapKeyboardShortcutsToObjects(action.payload.keyboardShortcuts),
                kiosk: action.payload.kiosk,
                lastUsedUnit: unitToShow,
                lightAtStartup: windowService.getLightAtStartup(),
                lightEnabled: action.payload.lightEnabled,
                locale: action.payload.locale,
                lockComputer: action.payload.lockComputer,
                manualAdditionUnit: action.payload.manualAdditionUnit,
                masterProductName: action.payload.masterProductName,
                masterProductSiblingsTable: action.payload.masterProductSiblingsTable,
                matchingInfoCr: action.payload.matchingInfoCr,
                matchingInfoDeltaE1: action.payload.matchingInfoDeltaE1,
                matchingInfoDeltaE2: action.payload.matchingInfoDeltaE2,
                matchingInfoDeltaE3: action.payload.matchingInfoDeltaE3,
                matchingInfoDin: action.payload.matchingInfoDin,
                matchingInfoLrv: action.payload.matchingInfoLrv,
                matchingInfoRms: action.payload.matchingInfoRms,
                matchingOptionsColorants: action.payload.matchingOptionsColorants,
                matchingOptionsColorfile: action.payload.matchingOptionsColorfile,
                matchingOptionsSortResults: action.payload.matchingOptionsSortResults,
                matchingRowCount: action.payload.matchingRowCount,
                matchingTableBase: action.payload.matchingTableBase,
                matchingTableColorants: action.payload.matchingTableColorants,
                matchingTableCr: action.payload.matchingTableCr,
                matchingTableDeltaE1: action.payload.matchingTableDeltaE1,
                matchingTableDeltaE2: action.payload.matchingTableDeltaE2,
                matchingTableDeltaE3: action.payload.matchingTableDeltaE3,
                matchingTableDin: action.payload.matchingTableDin,
                matchingTableLrv: action.payload.matchingTableLrv,
                matchingTablePrice: action.payload.matchingTablePrice,
                matchingTableRms: action.payload.matchingTableRms,
                maxNumberOfTabs: action.payload.tabsEnabled ? action.payload.maxNumberOfTabs : 1,
                maxToleranceForCompetitiveColors: action.payload.maxToleranceForCompetitiveColors,
                moreInfoInternal: action.payload.moreInfoInternal,
                navigationItems: action.payload.navigationItems,
                numberOfCompetitiveColors: action.payload.numberOfCompetitiveColors,
                orderingEnabled: action.payload.orderingEnabled,
                orderModalEnabled: action.payload.orderModalEnabled,
                orderSearchItemsEnabled: action.payload.orderSearchItemsEnabled,
                overwriteHelperConfig: action.payload.overwriteHelperConfig,
                overwriteLastTab: action.payload.tabsEnabled ? action.payload.overwriteLastTab : true,
                overwriteLogo: action.payload.overwriteLogo,
                overwriteMachineConfig: action.payload.overwriteMachineConfig,
                partialUpdatesInactivityTimer: action.payload.partialUpdatesInactivityTimer,
                partialUpdatesRemindInterval: action.payload.partialUpdatesRemindInterval,
                priceTypes: action.payload.priceTypes,
                priceVisibilityType: action.payload.priceVisibilityType,
                pricingEnabled: action.payload.pricingEnabled,
                printAfterDispensing: action.payload.printAfterDispensing,
                printAsImage: action.payload.printAsImage,
                printBeforeDispensing: action.payload.printBeforeDispensing,
                printEnabled: action.payload.printEnabled,
                printer: action.payload.printer,
                printerTemplate: action.payload.printerTemplate,
                printerTemplateQuickTint: action.payload.printerTemplateQuickTint,
                printOnRequest: action.payload.printOnRequest,
                printTasksAfterDispensing: modelHelper.mapPrintTasksToObjects(action.payload.printTasksAfterDispensing),
                printTasksBeforeDispensing: modelHelper.mapPrintTasksToObjects(
                    action.payload.printTasksBeforeDispensing
                ),
                productCode: action.payload.productCode,
                productFilesSource: action.payload.productFilesSource,
                productGroups: action.payload.productGroups,
                productImagePreview: action.payload.productImagePreview,
                qualityControlDifference: action.payload.qualityControlDifference,
                qualityControlDeltaA: action.payload.qualityControlDeltaA,
                qualityControlDeltaB: action.payload.qualityControlDeltaB,
                qualityControlDeltaE: action.payload.qualityControlDeltaE,
                qualityControlDeltaL: action.payload.qualityControlDeltaL,
                qualityControlEnabled: action.payload.qualityControlEnabled,
                qualityControlMetamerism: action.payload.qualityControlMetamerism,
                quickTintSortingType: action.payload.quickTintSortingType,
                quickTintWindowCloseAfterDispensing: action.payload.quickTintWindowCloseAfterDispensing,
                rccBarcodeRefill: action.payload.rccBarcodeRefill,
                rccBaseCanBarcodeValidation: action.payload.rccBaseCanBarcodeValidation,
                rccDispenseInvalidColorants: action.payload.rccDispenseInvalidColorants,
                rccCheckCanBeforeDispense: action.payload.rccCheckCanBeforeDispense,
                rccCheckOverfill: action.payload.rccCheckOverfill,
                rccManualColorantAddition: action.payload.rccManualColorantAddition,
                rccMinimalDispenseAmount: action.payload.rccMinimalDispenseAmount,
                rccPlaceCanSensor: action.payload.rccPlaceCanSensor,
                rccPlaceCanSensorDelay: action.payload.rccPlaceCanSensorDelay,
                rccRemoveCanSensor: action.payload.rccRemoveCanSensor,
                rccRemoveCanSensorDelay: action.payload.rccRemoveCanSensorDelay,
                rccSkipPlaceCanDialog: action.payload.rccSkipPlaceCanDialog,
                rccSkipRemoveCanDialog: action.payload.rccSkipRemoveCanDialog,
                rccSplitFormula: action.payload.rccSplitFormula,
                rccTmcEnabled: action.payload.rccTmcEnabled,
                rccUnit: action.payload.rccUnit,
                rccValidateColorantsDuringInit: action.payload.rccValidateColorantsDuringInit,
                recirculationSpeed: action.payload.recirculationSpeed,
                recirculationTime: action.payload.recirculationTime,
                rounding: action.payload.rounding,
                screensaverTimeout: action.payload.screensaverTimeout,
                searchCheaperColors: action.payload.searchCheaperColors,
                searchPanelBase: action.payload.searchPanelBase,
                searchPanelBaseSize: action.payload.searchPanelBaseSize,
                searchPanelBipp: action.payload.searchPanelBipp,
                searchPanelBippSize: action.payload.searchPanelBippSize,
                searchPanelDropDownCalculate: action.payload.searchPanelDropDownCalculate,
                searchPanelFandeckSize: action.payload.searchPanelFandeckSize,
                searchPanelFormulaSize: action.payload.searchPanelFormulaSize,
                searchPanelOrder: action.payload.searchPanelOrder,
                searchPanelOrderByDistance: action.payload.searchPanelOrderByDistance,
                searchPanelProduct: action.payload.searchPanelProduct,
                searchPanelProductSize: action.payload.searchPanelProductSize,
                searchPanelQuickSelect: action.payload.searchPanelQuickSelect,
                shotsCoef: action.payload.shotsCoef === 0 ? 1 : action.payload.shotsCoef,
                shotsName: action.payload.shotsName,
                softwareName: action.payload.softwareName,
                softwareNameLight: action.payload.softwareNameLight,
                soundEnabled: action.payload.soundEnabled,
                spectroEnabled: action.payload.spectroEnabled,
                stirringSpeed: action.payload.stirringSpeed,
                stirringTime: action.payload.stirringTime,
                stockDatabaseFilter: action.payload.stockDatabaseFilter,
                stockTableOrderBy: action.payload.stockTableOrderBy,
                style: customStyle === null ? state.style : customStyle,
                tableAnswer: action.payload.tableAnswer,
                tableBase: action.payload.tableProduct,
                tableBipp: action.payload.tableBipp,
                tableBuildingSite: action.payload.tableBuildingSite,
                tableClientName: action.payload.tableClientName,
                tableColorName: action.payload.tableColorName,
                tableCreated: action.payload.tableCreated,
                tableCustomer: action.payload.tableCustomer,
                tableDate: action.payload.tableDate,
                tableFandeck: action.payload.tableFandeck,
                tableFormulaCode: action.payload.tableFormulaCode,
                tableFormulaName: action.payload.tableFormulaName,
                tableMoreInfo: action.payload.tableMoreInfo,
                tableMoreInfoInternal: action.payload.tableMoreInfoInternal,
                tableOperator: action.payload.tableOperator,
                tablePackage: action.payload.tablePackage,
                tableProduct: action.payload.tableProduct,
                tableQualityControl: action.payload.tableQualityControl,
                tableQuantity: action.payload.tableQuantity,
                tableStatus: action.payload.tableStatus,
                tableSubject: action.payload.tableSubject,
                tableTicketId: action.payload.tableTicketId,
                tabsEnabled: action.payload.tabsEnabled,
                tabsMemory: action.payload.tabsMemory,
                tintometricSystem: action.payload.tintometricSystem,
                tintometricSystemsEnabled: action.payload.tintometricSystemsEnabled,
                ufiCodeBaseValidation: action.payload.ufiCodeBaseValidation,
                ufiCodeLogic: action.payload.ufiCodeLogic,
                ufiCodeMinAmountGravPercent: action.payload.ufiCodeMinAmountGravPercent,
                ufiCodeMinGravPercent: action.payload.ufiCodeMinGravPercent,
                userIdentificationEnabled: action.payload.userIdentificationEnabled,
                validateColorantBaseRules: action.payload.validateColorantBaseRules,
                validateMinDosableAmount: action.payload.validateMinDosableAmount,
                validateOverfill: action.payload.validateOverfill,
                validateTotalCntAmounts: action.payload.validateTotalCntAmounts,
                virtualKeyboardEnabled: action.payload.virtualKeyboardEnabled,
                visibleUnits: action.payload.visibleUnits,
                zoom: action.payload.zoom
            };
        case actionTypes.SETTINGS_SAVE_ADDITIONAL_TAB_TYPE:
            return {
                ...state,
                additionalTabType: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_ALTERNATIVE_FORMULAS_POSITION:
            return {
                ...state,
                alternativeFormulasPosition: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_AUTO_CLOSE_TAB:
            return {
                ...state,
                autoCloseTab: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_AUTOMATIC_CLIENT_START:
            return {
                ...state,
                automaticClientStart: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_AUTOMATIC_LOGOUT:
            window.storeProvider.setAutomaticLogout(action.payload.value, state.automaticLogoutTimeout);
            return {
                ...state,
                automaticLogout: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_AUTOMATIC_LOGOUT_TIMEOUT:
            window.storeProvider.setAutomaticLogout(state.automaticLogout, action.payload.value);
            return {
                ...state,
                automaticLogoutTimeout: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_AUTOMATIC_PRINT:
            return {
                ...state,
                automaticPrint: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_BARCODES_ENABLED:
            return {
                ...state,
                barcodesEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_BLEND_FORMULA_AND_CODE:
            window.storeProvider.setFormulaListOrder(action.payload.value, state.formulaCodePrimary);
            return {
                ...state,
                blendFormulaAndCode: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_BUILDING_SITE:
            return {
                ...state,
                buildingSite: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CLEANING_TIME:
            return {
                ...state,
                cleaningTime: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLORANT_BATCH_NUMBER_LOGIC:
            return {
                ...state,
                colorantBatchNumberLogic: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLORANT_BATCH_FOR_MULTIPLE_CANS:
            return {
                ...state,
                colorantBatchForMultipleCans: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLORANT_PANEL_LIMIT:
            return {
                ...state,
                colorantPanelLimit: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLORANT_PANEL_ORDER_BY:
            return {
                ...state,
                colorantPanelOrderBy: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_PREVIEW_AS_IMAGE:
            return {
                ...state,
                colorPreviewAsImage: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_PREVIEW_RESIZABLE:
            return {
                ...state,
                colorPreviewResizable: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_TAB_COMPATIBLE_ONLY:
            return {
                ...state,
                colorTabCompatibleOnly: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_TAB_FORMULA_CODE:
            return {
                ...state,
                colorTabFormulaCode: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_TAB_FORMULA_NAME:
            return {
                ...state,
                colorTabFormulaName: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_TAB_NOTE_ICONS:
            return {
                ...state,
                colorTabNoteIcons: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_TAB_ORDER_BY:
            return {
                ...state,
                colorTabOrderBy: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_TAB_ROW_COUNT:
            return {
                ...state,
                colorTabRowCount: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_TAB_WARNING_ICON:
            return {
                ...state,
                colorTabWarningIcon: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COMPETITIVE_COLOR_SEARCH:
            return {
                ...state,
                competitiveColorSearch: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_BANNER_POSITION:
            return {
                ...state,
                customBannerPosition: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_CAN_OPTION:
            return {
                ...state,
                customCanOption: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_GRAV:
            return {
                ...state,
                customCanSettingsUnitGrav: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_VOL:
            return {
                ...state,
                customCanSettingsUnitVol: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_CAN_SIZE:
            return {
                ...state,
                customCanSizeEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_CAN_UNITS:
            return {
                ...state,
                customCanUnits: Array.isArray(action.payload.value) ? action.payload.value : []
            };
        case actionTypes.SETTINGS_SAVE_CUSTOMERS_ENABLED:
            return {
                ...state,
                customersEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_CURRENCY:
            window.storeProvider.setCustomFormatCurrency(action.payload.value);
            return {
                ...state,
                customFormatCurrency: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_DATE:
            window.storeProvider.setCustomFormatDateTime(action.payload.value, state.customFormatTime);
            return {
                ...state,
                customFormatDate: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_NUMBER:
            window.storeProvider.setCustomFormatNumber(action.payload.value);
            return {
                ...state,
                customFormatNumber: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_TIME:
            window.storeProvider.setCustomFormatDateTime(state.customFormatDate, action.payload.value);
            return {
                ...state,
                customFormatTime: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT:
            return {
                ...state,
                customFormulaForMasterProduct: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT_DEFAULT:
            window.storeProvider.setCustomFormulaForMasterProductDefault(action.payload.value);

            return {
                ...state,
                customFormulaForMasterProductDefault: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_FORMULAS:
            return {
                ...state,
                customFormulas: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_CUSTOM_HOME_BUTTON:
            return {
                ...state,
                customHomeButton: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DELETE_CONFIRMATION:
            return {
                ...state,
                deleteConfirmation: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DISK_SPACE_NOTIFICATION:
            window.storeProvider.setDiskSpaceNotification(action.payload.value);
            return {
                ...state,
                diskSpaceNotification: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DISPENSING_ENABLED:
            return {
                ...state,
                dispensingEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DISPENSING_NOTES:
            return {
                ...state,
                dispensingNotes: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DISPENSING_WITH_ERRORS_ENABLED:
            return {
                ...state,
                dispensingWithErrorsEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_EDIT_COLORANT_ALLOWANCE:
            return {
                ...state,
                editColorantAllowance: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FILE_TRANSFER:
            return {
                ...state,
                fileTransfer: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FILE_TRANSFER_IN_TASKS:
            return {
                ...state,
                fileTransferInTasks: modelHelper.mapFileTransferInTasksToObjects(action.payload.value)
            };
        case actionTypes.SETTINGS_SAVE_FILE_TRANSFER_OUT_TASKS:
            return {
                ...state,
                fileTransferOutTasks: modelHelper.mapFileTransferOutTasksToObjects(action.payload.value)
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_AUTOMATIC_NAMING:
            return {
                ...state,
                formulaAutomaticNaming: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_CODE:
            return {
                ...state,
                formulaCode: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_CODE_PRIMARY:
            window.storeProvider.setFormulaListOrder(state.blendFormulaAndCode, action.payload.value);
            return {
                ...state,
                formulaCodePrimary: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_COLOR_PREVIEW:
            return {
                ...state,
                formulaColorPreview: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_INFO_DATA:
            return {
                ...state,
                formulaInfoData: Array.isArray(action.payload.value) ? action.payload.value : []
            };
        case actionTypes.SETTINGS_SAVE_INFO_ITEM_IN_RGB_PREVIEW:
            return {
                ...state,
                formulaInfoItemInRgbPreview: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_MODIFICATION_PANEL:
            return {
                ...state,
                formulaModificationPanel: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_NAME:
            return {
                ...state,
                formulaName: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_NOTES:
            return {
                ...state,
                formulaNotes: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_PREVIEW:
            return {
                ...state,
                formulaPreview: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_PROPERTIES_POSITION:
            return {
                ...state,
                formulaPropertiesPosition: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_STATUS_PANEL:
            return {
                ...state,
                formulaStatusPanel: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FORMULA_UNITS:
            return {
                ...state,
                formulaUnits: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FTS:
            return {
                ...state,
                fts: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_GENERATE_COLOR_PREVIEW:
            return {
                ...state,
                generateColorPreview: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_DOWNLOAD:
            return {
                ...state,
                helperAutoDownload: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_FORCE_INSTALL:
            return {
                ...state,
                helperAutoForceInstall: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_CHECK:
            return {
                ...state,
                helperAutoCheck: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_CHECK_INTERVAL:
            return {
                ...state,
                helperAutoCheckInterval: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_INSTALL:
            return {
                ...state,
                helperAutoInstall: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_INSTALL_DELAY:
            return {
                ...state,
                helperAutoInstallDelay: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_INSTALL_NEW_DBS:
            return {
                ...state,
                helperAutoInstallNewDbs: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_NIGHT_CHECK:
            return {
                ...state,
                helperAutoNightCheck: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELP_LINK:
            return {
                ...state,
                helpLink: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_HELP:
            return {
                ...state,
                helpSettings: settingsHelper.parseHelpItems(action.payload.value)
            };
        case actionTypes.SETTINGS_SAVE_HISTORICAL_FORMULAS_POSITION:
            return {
                ...state,
                historicalFormulasPosition: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_IMAGES_SOURCE:
            return {
                ...state,
                imagesSource: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_INFO_PANEL_RESIZABLE:
            return {
                ...state,
                infoPanelResizable: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_INFO_PANEL_TAB:
            return {
                ...state,
                infoPanelTab: action.payload.value ? action.payload.value : settings.INFO_PANEL_PACKAGE
            };
        case actionTypes.SETTINGS_SAVE_INITIAL_TAB_TYPE:
            return {
                ...state,
                initialTabType: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_COLOR_FANDECK_WIZARD:
            return {
                ...state,
                intergammaColorFandeckWizard: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MACHINE_SORTING_ORDERS:
            return {
                ...state,
                intergammaMachineSortingOrders: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_KEYBOARD:
            return {
                ...state,
                keyboard: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_KEYBOARD_SHORTCUTS:
            return {
                ...state,
                keyboardShortcuts: modelHelper.mapKeyboardShortcutsToObjects(action.payload.value)
            };
        case actionTypes.SETTINGS_SAVE_KIOSK:
            return {
                ...state,
                kiosk: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_ACTIVE_FORMULA_UNIT:
            return {
                ...state,
                lastUsedUnit: action.payload.value ? action.payload.value : settings.UNIT_ML
            };
        case actionTypes.SETTINGS_SAVE_LIGHT_AT_STARTUP:
            return {
                ...state,
                lightAtStartup: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_REDLIKE_LIGHT_ENABLED:
            return {
                ...state,
                lightEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_LOCALE:
            return {
                ...state,
                locale: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_LOCK_COMPUTER:
            return {
                ...state,
                lockComputer: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MANUAL_ADDITION_UNIT:
            return {
                ...state,
                manualAdditionUnit: action.payload.value ? action.payload.value : settings.UNIT_ML
            };
        case actionTypes.SETTINGS_SAVE_MASTER_PRODUCT_SIBLINGS_TABLE:
            return {
                ...state,
                masterProductSiblingsTable: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_INFO_CR:
            return {
                ...state,
                matchingInfoCr: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_INFO_DELTA_E1:
            return {
                ...state,
                matchingInfoDeltaE1: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_INFO_DELTA_E2:
            return {
                ...state,
                matchingInfoDeltaE2: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_INFO_DELTA_E3:
            return {
                ...state,
                matchingInfoDeltaE3: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_INFO_DIN:
            return {
                ...state,
                matchingInfoDin: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_INFO_LRV:
            return {
                ...state,
                matchingInfoLrv: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_INFO_RMS:
            return {
                ...state,
                matchingInfoRms: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_OPTIONS_COLORANTS:
            return {
                ...state,
                matchingOptionsColorants: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_OPTIONS_COLORFILE:
            return {
                ...state,
                matchingOptionsColorfile: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_OPTIONS_SORT_RESULTS:
            return {
                ...state,
                matchingOptionsSortResults: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_ROW_COUNT:
            return {
                ...state,
                matchingRowCount: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_BASE:
            return {
                ...state,
                matchingTableBase: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_COLORANTS:
            return {
                ...state,
                matchingTableColorants: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_CR:
            return {
                ...state,
                matchingTableCr: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DELTA_E1:
            return {
                ...state,
                matchingTableDeltaE1: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DELTA_E2:
            return {
                ...state,
                matchingTableDeltaE2: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DELTA_E3:
            return {
                ...state,
                matchingTableDeltaE3: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DIN:
            return {
                ...state,
                matchingTableDin: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_LRV:
            return {
                ...state,
                matchingTableLrv: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_PRICE:
            return {
                ...state,
                matchingTablePrice: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MATCHING_TABLE_RMS:
            return {
                ...state,
                matchingTableRms: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_NUMBER_OF_TABS:
            return {
                ...state,
                maxNumberOfTabs: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MAX_TOLERANCE_OF_COMPETITIVE_COLORS:
            return {
                ...state,
                maxToleranceForCompetitiveColors: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_MORE_INFO_INTERNAL:
            return {
                ...state,
                moreInfoInternal: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_NAVIGATION_ITEMS:
            return {
                ...state,
                navigationItems: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_NUMBER_OF_COMPETITIVE_COLORS:
            return {
                ...state,
                numberOfCompetitiveColors: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_ORDERING_ENABLED:
            return {
                ...state,
                orderingEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_ORDER_MODAL_ENABLED:
            return {
                ...state,
                orderModalEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_ORDER_SEARCH_ITEMS:
            return {
                ...state,
                orderSearchItemsEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_OVERWRITE_LAST_TAB:
            return {
                ...state,
                overwriteLastTab: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRICE_TYPES:
            return {
                ...state,
                priceTypes: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRICE_VISIBILITY_TYPE:
            return {
                ...state,
                priceVisibilityType: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRICING_ENABLED:
            return {
                ...state,
                pricingEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRINT_AFTER_DISPENSING:
            return {
                ...state,
                printAfterDispensing: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRINT_AS_IMAGE:
            return {
                ...state,
                printAsImage: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRINT_BEFORE_DISPENSING:
            return {
                ...state,
                printBeforeDispensing: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRINT_ENABLED:
            return {
                ...state,
                printEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DEFAULT_PRINTER:
            return {
                ...state,
                printer: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DEFAULT_TEMPLATE:
            return {
                ...state,
                printerTemplate: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_DEFAULT_TEMPLATE_QUICKTINT:
            return {
                ...state,
                printerTemplateQuickTint: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_FANDECK_GROUPS:
            return {
                ...state,
                fandeckGroups: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRINT_ON_REQUEST:
            return {
                ...state,
                printOnRequest: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRINT_TASKS_AFTER_DISPENSING:
            return {
                ...state,
                printTasksAfterDispensing: modelHelper.mapPrintTasksToObjects(action.payload.value)
            };
        case actionTypes.SETTINGS_SAVE_PRINT_TASKS_BEFORE_DISPENSING:
            return {
                ...state,
                printTasksBeforeDispensing: modelHelper.mapPrintTasksToObjects(action.payload.value)
            };
        case actionTypes.SETTINGS_SAVE_PRODUCT_CODE:
            return {
                ...state,
                productCode: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRODUCT_FILES_SOURCE:
            return {
                ...state,
                productFilesSource: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRODUCT_GROUPS:
            return {
                ...state,
                productGroups: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_PRODUCT_IMAGE_PREVIEW_ENABLED:
            return {
                ...state,
                productImagePreview: action.payload.value
            };

        case actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_A:
            return {
                ...state,
                qualityControlDeltaA: action.payload.value
            };

        case actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_B:
            return {
                ...state,
                qualityControlDeltaB: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_COLOR_DIFFERENCE:
            return {
                ...state,
                qualityControlDifference: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_E:
            return {
                ...state,
                qualityControlDeltaE: action.payload.value
            };

        case actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_ENABLED:
            return {
                ...state,
                qualityControlEnabled: action.payload.value
            };

        case actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_L:
            return {
                ...state,
                qualityControlDeltaL: action.payload.value
            };

        case actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_METAMERISM:
            return {
                ...state,
                qualityControlMetamerism: action.payload.value
            };

        case actionTypes.SETTINGS_SAVE_QUICK_TINT_SORTING_TYPE:
            return {
                ...state,
                quickTintSortingType: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_QUICK_TINT_WINDOW_CLOSING_RULE:
            return {
                ...state,
                quickTintWindowCloseAfterDispensing: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_BARCODE_REFILL:
            return {
                ...state,
                rccBarcodeRefill: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_BASE_CAN_BARCODE_VALIDATION:
            return {
                ...state,
                rccBaseCanBarcodeValidation: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_DISPENSE_INVALID_COLORANTS:
            return {
                ...state,
                rccDispenseInvalidColorants: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_CHECK_CAN_BEFORE_DISPENSE:
            return {
                ...state,
                rccCheckCanBeforeDispense: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_CHECK_OVERFILL:
            return {
                ...state,
                rccCheckOverfill: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_MANUAL_COLORANT_ADDITION:
            return {
                ...state,
                rccManualColorantAddition: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_MINIMAL_DISPENSE_AMOUNT:
            return {
                ...state,
                rccMinimalDispenseAmount: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR:
            return {
                ...state,
                rccPlaceCanSensor: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR_DELAY:
            return {
                ...state,
                rccPlaceCanSensorDelay: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR:
            return {
                ...state,
                rccRemoveCanSensor: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR_DELAY:
            return {
                ...state,
                rccRemoveCanSensorDelay: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_SKIP_PLACE_CAN_DIALOG:
            return {
                ...state,
                rccSkipPlaceCanDialog: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_SKIP_REMOVE_CAN_DIALOG:
            return {
                ...state,
                rccSkipRemoveCanDialog: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_SPLIT_FORMULA:
            return {
                ...state,
                rccSplitFormula: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_TMC_ENABLED:
            return {
                ...state,
                rccTmcEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_UNIT:
            return {
                ...state,
                rccUnit: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RCC_VALIDATE_COLORANTS_DURING_INIT:
            return {
                ...state,
                rccValidateColorantsDuringInit: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RECIRCULATION_SPEED:
            return {
                ...state,
                recirculationSpeed: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_RECIRCULATION_TIME:
            return {
                ...state,
                recirculationTime: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_ROUNDING:
            window.storeProvider.setRounding(action.payload.value);

            return {
                ...state,
                rounding: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SCREENSAVER_TIMEOUT:
            window.storeProvider.setScreenSaverTimeout(action.payload.value);

            return {
                ...state,
                screensaverTimeout: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_CHEAPER_COLORS:
            return {
                ...state,
                searchCheaperColors: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BASE:
            return {
                ...state,
                searchPanelBase: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BASE_SIZE:
            return {
                ...state,
                searchPanelBaseSize: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BIPP:
            return {
                ...state,
                searchPanelBipp: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BIPP_SIZE:
            return {
                ...state,
                searchPanelBippSize: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_DROP_DOWN_CALCULATE:
            return {
                ...state,
                searchPanelDropDownCalculate: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_FANDECK_SIZE:
            return {
                ...state,
                searchPanelFandeckSize: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_FORMULA_SIZE:
            return {
                ...state,
                searchPanelFormulaSize: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER:
            if (!Array.isArray(action.payload.value)) {
                return state;
            }

            return {
                ...state,
                searchPanelOrder: settingsHelper.processSearchPanelOrderSetting(
                    action.payload.value,
                    state.formulaName,
                    state.formulaCode,
                    state.blendFormulaAndCode,
                    state.searchPanelBase,
                    state.searchPanelBipp,
                    state.searchPanelProduct
                )
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER_BY_DISTANCE:
            return {
                ...state,
                searchPanelOrderByDistance: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_PRODUCT:
            return {
                ...state,
                searchPanelProduct: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_PRODUCT_SIZE:
            return {
                ...state,
                searchPanelProductSize: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SEARCH_PANEL_QUICK_SELECT:
            return {
                ...state,
                searchPanelQuickSelect: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SOUND_ENABLED:
            return {
                ...state,
                soundEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_SPECTRO_ENABLED:
            return {
                ...state,
                spectroEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_STIRRING_SPEED:
            return {
                ...state,
                stirringSpeed: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_STIRRING_TIME:
            return {
                ...state,
                stirringTime: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_STOCK_DATABASE_FILTER:
            return {
                ...state,
                stockDatabaseFilter: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_STOCK_TABLE_ORDER_BY:
            return {
                ...state,
                stockTableOrderBy: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_ANSWER:
            return {
                ...state,
                tableAnswer: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_BASE:
            return {
                ...state,
                tableBase: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_BIPP:
            return {
                ...state,
                tableBipp: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_BUILDING_SITE:
            return {
                ...state,
                tableBuildingSite: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_CLIENT_NAME:
            return {
                ...state,
                tableClientName: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_CREATED:
            return {
                ...state,
                tableCreated: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_CUSTOMER:
            return {
                ...state,
                tableCustomer: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_DATE:
            return {
                ...state,
                tableDate: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_FANDECK:
            return {
                ...state,
                tableFandeck: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_FORMULA_CODE:
            return {
                ...state,
                tableFormulaCode: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_COLOR_NAME:
            return {
                ...state,
                tableColorName: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_COMMENT:
            return {
                ...state,
                tableComment: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_FORMULA_NAME:
            return {
                ...state,
                tableFormulaName: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_MORE_INFO:
            return {
                ...state,
                tableMoreInfo: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_MORE_INFO_INTERNAL:
            return {
                ...state,
                tableMoreInfoInternal: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_OPERATOR:
            return {
                ...state,
                tableOperator: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_PACKAGE:
            return {
                ...state,
                tablePackage: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_PRODUCT:
            return {
                ...state,
                tableProduct: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_QUALITY_CONTROL:
            return {
                ...state,
                tableQualityControl: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_QUANTITY:
            return {
                ...state,
                tableQuantity: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_STATUS:
            return {
                ...state,
                tableStatus: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_SUBJECT:
            return {
                ...state,
                tableSubject: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_TICKET_ID:
            return {
                ...state,
                tableTicketId: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABLE_TYPE:
            return {
                ...state,
                tableType: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TABS_ENABLED:
            if (action.payload.value) {
                return {
                    ...state,
                    tabsEnabled: true
                };
            }

            return {
                ...state,
                maxNumberOfTabs: 1,
                overwriteLastTab: true,
                tabsEnabled: false
            };
        case actionTypes.SETTINGS_SAVE_TABS_MEMORY:
            return {
                ...state,
                tabsMemory: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_TINTOMETRIC_SYSTEM:
            return {
                ...state,
                tintometricSystem: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_UFI_CODE_BASE_VALIDATION:
            return {
                ...state,
                ufiCodeBaseValidation: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_UFI_CODE_LOGIC:
            return {
                ...state,
                ufiCodeLogic: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_UFI_CODE_MIN_AMOUNT_GRAV_PERCENT:
            return {
                ...state,
                ufiCodeMinAmountGravPercent: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_UFI_CODE_MIN_GRAV_PERCENT:
            return {
                ...state,
                ufiCodeMinGravPercent: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_USER_IDENTIFICATION:
            return {
                ...state,
                userIdentificationEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_VALIDATE_COLORANT_BASE_RULES:
            return {
                ...state,
                validateColorantBaseRules: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_VALIDATE_MIN_DOSABLE_AMOUNT:
            return {
                ...state,
                validateMinDosableAmount: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_VALIDATE_OVERFILL:
            return {
                ...state,
                validateOverfill: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_VALIDATE_TOTAL_CNT_AMOUNTS:
            return {
                ...state,
                validateTotalCntAmounts: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_VIRTUAL_KEYBOARD_ENABLED:
            return {
                ...state,
                virtualKeyboardEnabled: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_VISIBLE_UNITS:
            return {
                ...state,
                visibleUnits: action.payload.value
            };
        case actionTypes.SETTINGS_SAVE_ZOOM:
            window.storeProvider.setZoom(action.payload.value);

            return {
                ...state,
                zoom: action.payload.value
            };
        case actionTypes.SAVE_MACHINE_DRIVER_CONFIGURATION:
            if (
                action.payload.configuration === undefined ||
                action.payload.configuration === null ||
                action.payload.configuration[rcc.CONFIGURATION_GENERAL] === undefined
            ) {
                return state;
            }

            if (
                action.payload.configuration[rcc.CONFIGURATION_GENERAL].type === rcc.DRIVER_TYPE_MANUAL ||
                action.payload.configuration[rcc.CONFIGURATION_GENERAL].type === rcc.DRIVER_TYPE_MANUAL_SIMPLE
            ) {
                return state;
            }

            if (state.formulaUnits === settings.UNIT_MANUAL) {
                return {
                    ...state,
                    formulaUnits: settings.UNIT_ML
                };
            }

            return state;
        case actionTypes.SETTINGS_SAVE_HELPER_AUTO_REBOOT_DELAY:
            return {
                ...state,
                helperAutoRebootDelay: action.payload.value
            };
        default:
            return state;
    }
};
